module.exports = __webpack_public_path__ + "img/new_index_cases10.253c1c91.png";